import dayjs from "dayjs";

export const getAgeFromDob = (dob) => {
  if (!dob) return null;
  const age = dayjs().diff(dayjs(dob), "year");
  return Number.isFinite(age) ? age : null;
};
